

<!DOCTYPE html>
<!--
This is a starter template page. Use this page to start your new project from
scratch. This page gets rid of all links and provides the needed markup only.
-->



<html lang="en">

<app-header-ecomerce></app-header-ecomerce>

<style>

  .center {
      margin-left: auto;
      margin-right: auto;
      display: block;
      height:200px;
      width: 600px;
  }
  .centerdiv {
    margin-left: auto;
      margin-right: auto;
      
      text-align: center;
      background-color: black;
  }.backgroundDiv{
    text-align: center;
  opacity: 0.9;
  }.IconoWhatsApp{
  height: 0px;
}
img.whatsapp {
  position: fixed;
  width: 40px;
  bottom: 65px;
  right: 42px;
  color: #FFF;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  z-index: 100;
  display: none;
}
#appear.active{
  display:inline;
}
  </style>


<nav class="main-header navbar navbar-expand navbar-white navbar-light" style="height: 80px;" >
  <!-- Left navbar links -->
  <div id="targetInicio"></div>


  <!-- Right navbar links -->
  <ul class="navbar-nav lg-auto"  >
   
      <li class="nav-item" *ngIf="ocultarCarrito == false" >
        <a class="nav-link" data-widget="pushmenu"   role="button" style="height: 50px;">
          <i class="fas fa-bars" style="font-size: 34px;color:rgba(7, 7, 7, 0.638);margin-top: -6px; height: 48px;width: auto;"></i>
        </a>
      </li>

    

    <!-- Navbar Search -->
    <li class="nav-item">
      <a class="nav-link" data-widget="navbar-search" role="button" (click)="OnHabilitarBusqueda()" *ngIf="ocultarCarrito == false"  style="width: 48px;height: 48px;" >
        <i class="fas fa-search"style="font-size: 32px; color:rgba(7, 7, 7, 0.638); margin-top: -6px; " ></i>
      </a>
      <div class="navbar-search-block" >
        <form class="form-inline"  [formGroup]="formBuscar" >
          <div class="input-group input-group-sm" >
            <input class="form-control form-control-navbar" type="text"  aria-label="Search" style="font-size: 20pt;height: 48px;border: 2px solid #0A0A0A; color: #0b0b0b;font-weight: bold;background-color: #FFFFFF;;height: 52px;" formControlName="txtBuscar" (keyup.enter)="OnBuscarAll()" >
            <div class="input-group-append">
              <button class="btn btn-navbar" type="button"  (click)="OnBuscarAll()"   style="border: 2px solid #424949;"  >
                <i class="fas fa-search" style="font-size: 36px;"></i>
              </button>
              <button class="btn btn-navbar" type="button" data-widget="navbar-search"  (click)="OnCerrarBusqueda()" style="border: 2px solid #424949;">
                <i class="fas fa-times" style="font-size: 36px;"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </li>

  

  </ul>
  
 
  
  <ul    class="navbar-nav ml-auto">
    <li  class="nav-item" >
  
      <div >
        <img src="./assets/dist/img/titulo_andrea.png"  width="150" height="35"  />
       </div>
 
    
    </li>  

  </ul>

  <ul    class="navbar-nav ml-auto">

    



    <li  class="nav-item dropdown" *ngIf="tieneSession == true" >

      <a class="nav-link" data-toggle="dropdown" href="#" *ngIf="ocultarCarrito == false">
   

          <img src="./assets/dist/img/user.png"  width="auto" height="42px" style="margin-top: -16px;margin-right: -12px;"  />

   
        
      </a>
      <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
        <a href="#" class="dropdown-item">
          <!-- Message Start -->
          <div class="media">
          
            <div class="media-body">
              <h3 class="dropdown-item-title">
                {{nombreCuenta}}
                <span class="float-right text-sm text-danger"><i class="fas fa-star"></i></span>
              </h3>
              
            </div>
          </div>
          <!-- Message End -->
        </a>
        <div class="dropdown-divider"></div>
        <a  class="dropdown-item" (click)="logout()">
          <!-- Message Start -->
          <div class="media">
           
            <div class="media-body">
              <h3 class="dropdown-item-title">
              Cerrar sesión
                <span class="float-right text-sm text-muted"><i class="fas fa-star"></i></span>
              </h3>
              
            </div>
          </div>
          <!-- Message End -->
        </a>
       
       
        
      </div>

    </li>

    <li  class="nav-item"    *ngIf="ocultarCarrito == false" style="margin-right: 8px;margin-top: -8px;">
      <a href="#/carrito">
      <img src="./assets/dist/img/carro.png"  width="auto" height="46"   />
      </a>
    </li>

    <span style="color: rgb(50, 50, 50);font-size: 35px;font-weight:bold">{{CantidadItem}}</span>


      <!-- <a  href="#/carrito">
        <img  src="./assets/dist/img/carro.png" width="auto" height="54px"  >
      
      </a> -->
    
  


<!-- <a class="btn btn-danger btn-lg" href="#/carrito" style="color:rgb(255, 255, 255); background-image: url('./assets/dist/img/carro.png');background-color: transparent;background-size: 100% 100%;border-color: transparent;width: 52px; height: 52px;font-size: x-large;text-align: right;margin: 6px">
{{countpedido}}   
 
</a> -->




   


   


  </ul>
 






</nav>



  <!-- /.navbar -->

  <app-sidebar-ecomerce></app-sidebar-ecomerce>


  <div class="wrapper">
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container">
        <div class="row mb-2">
          <div class="col-sm-12">
            <div class="card card-success">
          
              <div class="centerdiv">
             
                  <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" >
                    <ol class="carousel-indicators" >
                      <br>
                      <br>
                      <br>
                      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active" ></li>
                      <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                      <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                     
                    </ol>
                    <div class="carousel-inner">
                      <div class="carousel-item active" >
                        <div > <img  class="center" src="./assets/dist/img/carrusel1.jpg" width="100%" height="50%"   class="img-fluid"> </div>   
                        
                      </div>
                      <div class="carousel-item" >
                         <img  class="center" src="./assets/dist/img/carrusel2.jpg" width="100%" height="50%"  class="img-fluid"> 
                      </div>
                      <div class="carousel-item">
                         <img  class="center" src="./assets/dist/img/carrusel3.jpg" class="img-fluid" width="100%" height="50%"  > 
                      </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev" style="width: 48px;">
                      <span class="carousel-control-custom-icon" aria-hidden="true">
                        <i class="fas fa-chevron-left" style="font-size:20px;"></i>
                      </span>
                    
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next" style="width: 48px;">
                      <span class="carousel-control-custom-icon" aria-hidden="true">
                        <i class="fas fa-chevron-right" style="font-size:20px;"></i>
                      </span>
                    
                    </a>
                  </div>

                


               
              </div>
         

           
            </div>  


            <div class="card card-success">
          
           
              <video [autoplay]="true" [muted]="true" [loop]="true" [controls]="true" width="100%" height="100%">
                <source [src]="'./assets/dist/img/andreabanner.mp4'" type="video/mp4" />
                
              </video>
          
            </div>
          </div>

          
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container">
  
         


          
          <div class="card card-success">
            
            
              <div class="row"   infiniteScroll
              [infiniteScrollDistance]="2"
              [infiniteScrollThrottle]="50"
              (scrolled)="onScroll()" >
               

          
                  <div class="col-6 col-lg-4" *ngFor="let datos  of content"    >
                
                    <!-- <div  [style.background-image]="'url(' + this.urlServerUpload$ + datos.imagen + this.tipoMedia$  +')'" style="height: 80%;width: 80%;background-color: transparent;"></div> -->
                       
                    <div  >
                      <div class="row" (click)="OnSelectProducto(datos.idProducto)">
                        <img 
                        src={{urlServerUpload$}}{{datos.imagen}}{{tipoMedia$}}
                        
                            > 
                    </div>
                  </div>
<!--                         
                          <img  style="height: 150%;width: 100%;"
                          src={{urlServerUpload$}}{{datos.imagen}}{{tipoMedia$}}
                              > -->
                  
                
                              <div class="col-8">
                                <label class="text-muted text-sm">{{datos.modelo}}</label><br>
                                <label class="text-muted text-sm">{{datos.descripcion}}</label>
                                <br>
                                <label class="text-muted text-sm">{{datos.precio | currency: 'Q'}}</label>
                               
                              </div>
                   
                  </div>
      
        
            


      

      
        

              </div>



       


        </div>
        <!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>
    <!-- /.content -->
    <div class="content">
      <div class="container">
        <div class="row">

          <div class="card card-success">
            <div class="card-body">
              
                <div class="col-12 col-sm-12" >

          <app-footer-sucursal-ecomerce></app-footer-sucursal-ecomerce>
        </div>
     
    </div>
  </div>
</div>
      </div>
    </div>

    <div class="IconoWhatsApp">
      <a
      href="https://wa.me/+50243185405?text=mensaje"
      target="_blank">
      <img id="appear"
        class="whatsapp"
        src="./assets/dist/img/whatsapp.png"
        alt="IconoWhatsApp"
      />
    </a>
  </div>


   
  </div>
  <!-- /.content-wrapper -->

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->

  </aside>
  <!-- /.control-sidebar -->

 
 

</div>
  <!-- Main Footer -->
<app-footer-ecomerce></app-footer-ecomerce>

</html>
